import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.string.replace.js";
export function hasClass(el, className) {
  if (!el || !className) {
    return false;
  }

  return el.classList.contains(className);
}
export function toggleClass(el, className) {
  if (!el || !className) {
    return false;
  }

  return el.classList.toggle(className);
}
export function addClass(el, className) {
  if (!el || !className) {
    return false;
  }

  var classList = className.split(/\s/);
  classList.forEach(function (str) {
    if (str) {
      el.classList.add(str);
    }
  });
  return true;
}
export function eleSiblings(target) {
  if (target && target.parentNode) {
    return Array.prototype.filter.call(target.parentNode.children, function (child) {
      return child !== target;
    });
  }

  return [];
}
export function removeClass(el, className) {
  var eles = Array.isArray(el) ? el : [el];
  eles.forEach(function (ele) {
    if (ele) {
      ele.classList.remove(className);
    }
  });
}
export function stringToDom(str) {
  var $content = document.createDocumentFragment();

  if (!str) {
    return $content;
  }

  var tmp = document.createElement('div');
  tmp.insertAdjacentHTML('beforeend', str);

  if (tmp.childElementCount === 1) {
    return tmp.firstElementChild;
  }

  while (tmp.firstChild) {
    $content.appendChild(tmp.firstChild);
  }

  return $content;
}
export function hasDom(el, className) {
  if (!el || !className) {
    return false;
  }

  var dom = el.querySelector(className);
  return !!dom;
}
export function query(ele, parent) {
  if (/^#/.test(ele)) {
    return document.getElementById(ele.replace('#', ''));
  }

  return (parent || document).querySelector(ele);
}